import Sidebar from "../components/sidebar";
import { App, Content, Message } from "./styles";

export default function ChatLayout(props: { children: React.ReactNode; sidebarHidden?: boolean }) {
  const { children, sidebarHidden } = props;

  return (
    <App>
      <Message>Currently Only available on desktop or large devices 😊.</Message>
      <Content>
        <Sidebar isHidden={sidebarHidden} />
        {children}
      </Content>
    </App>
  );
}
